import * as type from '../mutationTypes'
import api from '../../serve/api'
import auth from '../../utils/auth'

export const setUser = async ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get('user_token')
      .then(
        res => {
          // state.user = res.data
          commit(type.SET_USER, res.data);
          resolve(res)
        },
        error => {
          console.error(error.response)
          reject(error.response)
        }
      )
  })
    // try {
    //   await commit(type.SET_USER);
    // } catch (error) {
    //   console.error(error);
    // }
  };
  


export const setUsersList = async ({ commit }) => {
  try {
    commit(type.SET_USERS_LIST);
  } catch (error) {
    console.error(error);
  }
};


export const editeUser = async ({commit}, data) => {
  return new Promise((resolve, reject) => {
    api.put(`/user/${data.id}`, data)
      .then(
        (res) => {
          commit(type.SET_USERS_LIST)
          resolve(res)
        },
        (error) => {reject(error), console.error(error)}
      );
  });
}

export const createUser = async ({commit}, data) => {
  return new Promise((resolve, reject) => {
    api.post(`/user`, data)
      .then(
        (res) => {
          commit(type.SET_USERS_LIST)
          resolve(res)
        },
        (error) => {reject(error), console.error(error)}
      );
  });
}


export const deleteUser = async ({commit}, user_id) => {
  return new Promise((resolve, reject) => {
    api.delete(`/user/${user_id}`)
      .then(
        (res) => {
          commit(type.SET_USERS_LIST)
          resolve(res)
        },
        (error) => {reject(error), console.error(error)}
      );
  });
}

export const setVisibilityVisitantForm = ({state}, value) => {
  state.visitant.form_is_visible = value 
}


export const createVisitor = ({state}, data) => {

  return new Promise((resolve, reject) => {
    api.post(`/visitor`, data)
      .then(
        (res) => {
          resolve(res)
          auth.set_visitant(res.data)
        },
        (error) => {reject(error), console.error(error)}
      );
  });
}

export const verifyVisitor = ({state}, data) => {
  
    return new Promise((resolve, reject) => {
      api.get(`/visitor_verify`, { params: data})
        .then(
          (res) => {
            auth.set_visitant(res.data)
            resolve(res)
          },
          (error) => {reject(error), console.error(error)}
        );
    });
  }